import React from "react";
import {connect} from "react-redux";
import {Heading, Text} from "components/styled";
import styled from "styled-components";
import {howToUseLocalization} from "localization";
import ScrollArea from "react-scrollbar";

const HowToUse = ({selectedLanguage}) => {
    const {
        title,
        titleText1,
        text1,
        titleText2,
        text2a,
        text2b,
        text2c,
        text2d,
        text2e,
        titleText3,
        text3,
        titleText4,
        text4,
        titleText5,
        text5
    } = howToUseLocalization[selectedLanguage];

    return (
        <PopupContent lang={selectedLanguage}>
            <ScrollArea className="options" smoothScrolling minScrollSize={30}>
                <div className="main-title">{title}</div>
                <Content>
                    <Heading.h2>{titleText1}</Heading.h2>
                    <Text>{text1}</Text>
                    <Heading.h2>{titleText2}</Heading.h2>
                    <Text>{text2a}</Text>
                    <Text>{text2b}</Text>
                    <Text>{text2c}</Text>
                    <Text>{text2d}</Text>
                    <Text>{text2e}</Text>
                    <Heading.h2>{titleText3}</Heading.h2>
                    <Text>{text3}</Text>
                    <Heading.h2>{titleText4}</Heading.h2>
                    <Text>{text4}</Text>
                    <Heading.h2>{titleText5}</Heading.h2>
                    <Text>{text5}</Text>
                </Content>
            </ScrollArea>
        </PopupContent>
    );
};

const PopupContent = styled.div`
  div {
    font-family: ${props =>
    props.lang === "en"
        ? '"Work Sans", sans-serif'
        : '"Noto Sans", sans-serif'};
  }
`;

const Content = styled.div`
  margin-top: 40px;
  margin-right: 40px;
  h2 {
    font-size: ${props => (props.lang === "en" ? "18px" : "20px")};
    margin-bottom: 4px;
  }
  p {
    color: var(--color-theme);
    opacity: .7;
    font-size: ${props => (props.lang === "en" ? "14px" : "16px")};
    line-height: 1.5;
    margin-bottom: 20px;
    & + h2 {
      margin-top: 40px;
    }
  }
`;

export default connect(state => ({
    selectedLanguage: state.localizationReducers.selectedLanguage
}))(HowToUse);



// WEBPACK FOOTER //
// ./src/pages/howToUse/howToUse.js